import { LinkableEntityType } from '@api';
import { Anchor } from '@common';

type VenueAnchorPropsType = {
  venue: LinkableEntityType;
};

export const VenueAnchor: React.FC<VenueAnchorPropsType> = ({
  venue: { id, name },
}) => {
  return (
    <Anchor key={id} to={`/venues/$id`} params={{ id }}>
      {name}
    </Anchor>
  );
};
